import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthLayoutComponent} from './layouts/auth-layout/auth-layout.component';
import {AppLayoutComponent} from './layouts/app-layout/app-layout.component';
import {AuthGuardService} from '@services/guards/auth-guard.service';
import {ErrorPageComponent} from './pages/error-page/error-page.component';
import {OnlyIfErrorsService} from '@services/guards/only-if-errors.service';
import {apparatusModuleRoutes} from './pages/apparatus/apparatus-routing.module';
import {specialistModuleRoutes} from './pages/specialist/specialist-routing.module';
import {packagesRoutes} from './pages/packages/packages-routing.module';
import {organizationRoutes} from './pages/organization/organization-routing.module';
import {profileRoutes} from './pages/profile/profile-routing.module';
import {registrationRoutes} from './pages/registration/registration-routing.module';
import {notFoundRoutes} from './pages/not-found/not-found-routing.module';
import {ForbiddenPageComponent} from './pages/forbidden-page/forbidden-page.component';
import {workingObjectsRoutes} from './pages/working-objects/working-objects-routing.module';

export const appRoutes: Routes = [
    /**
     * Для авторизованных пользователей открываем приложение
     */
    {
        path: '',
        component: AppLayoutComponent,
        canActivate: [AuthGuardService],
        children: [
            /**
             * Редиректы
             */
            {path: '', redirectTo: 'packages', pathMatch: 'full'},
            {path: 'apparatus', redirectTo: 'equipment'},
            {path: 'apparatus-stock', redirectTo: 'equipment'},
            {path: 'wizard', redirectTo: 'packages'},
            {path: 'welcome', redirectTo: 'packages', pathMatch: 'full'},

            /**
             * Роутинг для Feature Modules
             */
            {path: 'equipment', children: apparatusModuleRoutes},
            {path: 'specialist', children: specialistModuleRoutes},
            {path: 'packages', children: packagesRoutes},
            {path: 'organization', children: organizationRoutes},
            {path: 'profile', children: profileRoutes},
            {path: 'objects', children: workingObjectsRoutes},
        ]
    },

    /**
     * Страницы блока авторизации
     */
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            /**
             * Редиректы
             */
            {path: 'login', redirectTo: 'registration'},

            {
                path: 'error',
                pathMatch: 'full',
                component: ErrorPageComponent,
                canActivate: [OnlyIfErrorsService],
                canDeactivate: [false],
                data: {title: 'Ошибка'}
            },
            {path: 'forbidden', pathMatch: 'full', component: ForbiddenPageComponent, data: {title: 'Недостаточно прав'}},

            /**
             * Lazy-load модули по страницам
             */
            {path: 'registration', children: registrationRoutes},
        ]
    },

    {
        path: '**',
        component: AuthLayoutComponent,
        children: notFoundRoutes
    },

];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {}
